var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("model-provider", {
    attrs: { service: _vm.service, "model-id": _vm.id },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var model = ref.model
          return [
            _c("b-card", [
              _c(
                "div",
                { staticClass: "flex flex-col gap-4" },
                [
                  _c("contact-list-form", {
                    ref: "form",
                    attrs: { model: model },
                    on: {
                      reset: function($event) {
                        return _vm.$router.back()
                      },
                      submit: _vm.storeContactList
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "reset-button-text",
                          fn: function() {
                            return [_vm._v(" Voltar ")]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm.id
                    ? [
                        _c("div", {
                          staticClass:
                            "w-full border-b border-t-0 border-grey mt-8 border-solid",
                          staticStyle: { height: "0px" }
                        }),
                        _c(
                          "div",
                          [
                            _c("contact-form", {
                              ref: "input-contact-form",
                              attrs: {
                                model: _vm.contactInput,
                                inline: "",
                                "inline-input": ""
                              },
                              on: {
                                submit: _vm.addContact,
                                search: _vm.searchContact
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "search-button",
                                    fn: function() {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.search-contact",
                                                modifiers: {
                                                  "search-contact": true
                                                }
                                              }
                                            ],
                                            attrs: {
                                              variant: "outline-primary"
                                            },
                                            on: { click: _vm.search }
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "SearchIcon" }
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "align-middle" },
                                              [_vm._v("Buscar")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "Grid",
                          {
                            key: _vm.gridKey,
                            ref: "grid",
                            attrs: {
                              expandable: "",
                              "force-filters": { from_list_id: _vm.id },
                              service: _vm.contactService
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function(actions) {
                                    return [
                                      !_vm.hide_delete
                                        ? _c("feather-icon", {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value: "contact_lists.delete",
                                                expression:
                                                  "`contact_lists.delete`"
                                              }
                                            ],
                                            staticClass:
                                              "cursor-pointer h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                                            attrs: { icon: "Trash2Icon" },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeContact(
                                                  actions.row
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm.showInlineEditing
                              ? _c(
                                  "template",
                                  { slot: "row-" + _vm.editingRow },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "bg-grey-light",
                                        attrs: { colspan: "5" }
                                      },
                                      [
                                        _c("contact-form", {
                                          ref: "inline-contact-form",
                                          attrs: {
                                            compact: "",
                                            model: _vm.inlineEdit,
                                            inline: ""
                                          },
                                          on: {
                                            submit: _vm.storeInline,
                                            reset: _vm.closeInline
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "reset-button-text",
                                                fn: function() {
                                                  return [_vm._v(" Cancelar ")]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _c("b-modal", {
              attrs: { "ok-only": "", size: "xl", id: "search-contact" },
              on: { ok: _vm.addSelectedContacts },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("Grid", {
                          ref: "grid",
                          attrs: {
                            "multiple-select": "",
                            expandable: "",
                            service: _vm.contactService
                          },
                          on: { changedSelection: _vm.updateSelectedContacts }
                        })
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "modal-title",
                    fn: function() {
                      return [_vm._v(" Buscar Contato ")]
                    },
                    proxy: true
                  },
                  {
                    key: "modal-ok",
                    fn: function() {
                      return [_vm._v(" Adicionar ")]
                    },
                    proxy: true
                  },
                  {
                    key: "modal-cancel",
                    fn: function() {
                      return [_vm._v(" Voltar ")]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }